<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <path class="a" :class="{red, gray}" d="M7,0l7,14H0Z"/>
  </svg>
</template>

<script>
export default {
  name: "TrendUpIcon",
  props: {
    red: {
      type: Boolean,
      default: false
    },
    gray: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">

.a {
  fill: #57b98f;

  &.red {
    fill: #dd227b;
  }

  &.gray {
    fill: #707070;
  }

}
</style>
